<div class="d-flex align-items-center">
    <fal i="users" class="icon text-primary ml-3 mr-1"></fal>
    <app-advanced-input [(ngModel)]="payerFilter"
                        (ngModelChange)="onPayerFilterChange($event)"
                        [selectItems]="payerOptions"
                        type="select"
                        placeholder="Level of Care"
                        class="body-select"
                        style="width: 14em;"
                        bindLabel="label">
    </app-advanced-input>
</div>
